import React, { forwardRef } from "react";

import { AnnouncementBarBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { TextLink } from "../Clickables";

import styles from "./announcement-bar.module.scss";

interface Props {
    announcements: AnnouncementBarBlock;
    menuActive: boolean;
}

export const AnnouncementBar = forwardRef<HTMLDivElement, Props>(
    ({ announcements, menuActive }, ref) => {
        return (
            <div
                className={concatClassNames([
                    styles.root,
                    menuActive
                        ? styles.rootMenuActive
                        : styles.rootMenuInactive,
                ])}
                ref={ref}
            >
                <div className={styles.grid}>
                    <div className={styles.inner}>
                        {announcements.map((announcement) => (
                            <div key={announcement.id}>
                                <TextLink
                                    simpleLink={announcement.value}
                                    icon="arrow"
                                    className={styles.link}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    },
);
